import createGenericContext from 'common/components/CreateGenericContext';
import type { ResponsiveProviderContextType } from './types';

export const [useResponsiveContext, ResponsiveContextProvider, ResponsiveContextConsumer, withResponsiveContext] =
	createGenericContext<ResponsiveProviderContextType>({} as ResponsiveProviderContextType);
